export default __webpack_public_path__ + "static/media/side_view.ee7a522a.png";